// Indian number formatting, dates, times

export function formatINR(n, opts = {}) {
  if (n === null || n === undefined || isNaN(n)) return '₹0';
  const num = Number(n);
  const negative = num < 0;
  const abs = Math.abs(num);
  const [intPart, decPart] = abs.toFixed(2).split('.');
  // Indian grouping: last 3 digits, then groups of 2
  const last3 = intPart.slice(-3);
  const rest = intPart.slice(0, -3);
  const grouped = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3 : last3;
  const showPaise = opts.paise && decPart !== '00';
  return `${negative ? '-' : ''}₹${grouped}${showPaise ? '.' + decPart : ''}`;
}

export function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${String(d.getDate()).padStart(2,'0')} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export function isoToday() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export function parse12h(str) {
  // "04:30 AM" -> {h: 4, m: 30, ampm: 'AM'}
  if (!str) return { h: '', m: '', ampm: 'AM' };
  const m = str.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!m) return { h: '', m: '', ampm: 'AM' };
  return { h: parseInt(m[1]), m: parseInt(m[2]), ampm: m[3].toUpperCase() };
}

export function format12h({ h, m, ampm }) {
  if (h === '' || m === '' || h == null) return '';
  return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')} ${ampm}`;
}
